import { Container, Typography, Box } from '@mui/material';
import { HeroSection } from '../../components/marketing/HeroSection';
import { FaqAccordion } from '../../components/marketing/FaqAccordion';
import type { FaqItem } from '../../components/marketing/FaqAccordion';

const faqItems: FaqItem[] = [
  {
    question: 'How does it work?',
    answer:
      'Sign up in seconds, then hand us your tasks. Put your feet up while we do your dirty work.',
  },
  {
    question: 'Where are the assistants located?',
    answer: 'Assistants are located in the USA. All over the USA.',
  },
  {
    question: "Can your assistants work for me even though I'm in a different country?",
    answer:
      'Yes, we service clients worldwide, as long as we can speak English to complete your task.',
  },
  {
    question: 'What stuff will Fancy Hands do?',
    answer:
      "Anything that doesn't require us to physically go somewhere for you. Anything a smart, patient, internet-savvy person with a cell phone can conquer. As long as it's legal, we'll do it.",
  },
  {
    question: 'Can you make purchases for me?',
    answer:
      'Our dedicated assistants can make purchases for you. This feature is coming soon to all plans.',
  },
  {
    question: 'Can you do rush tasks?',
    answer:
      'We can handle most time-sensitive tasks, within reason. Please type "time sensitive" and note the deadline by which you need the task completed in your request subject line. However, we can\'t make any guarantees about speed.',
  },
  {
    question: 'Can you call countries outside the US?',
    answer:
      "Yep! We can call land lines and mobile phones in most countries. We CANNOT call toll numbers in other countries, like 900 numbers... and in some countries those are 800 numbers!",
  },
  {
    question: "What are your assistants' qualifications?",
    answer:
      "We hand-pick our assistants to ensure we've got smart, swift, and savvy folks with armfuls of patience at our consoles. Our hiring process involves rigorous interviews and tests.",
  },
  {
    question: 'Can I request an assistant who speaks a foreign language?',
    answer:
      'We work for English-speaking clients worldwide, but we do not work in other languages.',
  },
  {
    question: "What's the average turnaround time on a task?",
    answer:
      "We try our best to get it done as soon as we can and pride ourselves on being fast and thorough. Some tasks will only take a few minutes but often sorting out your cable bill can take a bit longer.",
  },
  {
    question: 'If an assistant makes calls for me, how will he or she represent themselves?',
    answer:
      "We will tell the party we're ringing that we're your assistant, and that we're calling on your behalf.",
  },
  {
    question: 'Will I get the same assistant for every request?',
    answer:
      "Nope. You may see some assistants more than others, but you won't be assigned a dedicated assistant (unless you sign up for our dedicated service). It's really better for you to be supported by a whole team than just one person.",
  },
  {
    question: 'Can I request a specific assistant?',
    answer:
      "You can ask for someone, but we can't guarantee anything. The extra hand you request may be busy assisting somebody else, or they could be on vacation.",
  },
  {
    question: 'How do I upgrade, downgrade, or cancel my service?',
    answer:
      'Head over to your billing info page and select the plan you want from the drop-down menu. To cancel your account, click on the link "cancel your account." No hard feelings.',
  },
  {
    question: 'At the end of the month, do my unused tasks roll over?',
    answer:
      'For standard plans, yes! Any unused tasks will roll over at the end of the month as long as your account is active. Dedicated plans are billed by the hour and do not have rollover — you simply pay for the time you use.',
  },
  {
    question: 'What if I have a large request that I need your help with?',
    answer:
      "Your assistant will work on your request until it gets done. For larger requests (something that is definitely going to take more than 15 minutes) we'll send you a note asking you to approve the use of additional requests to complete the job.",
  },
  {
    question: 'What if I have a task that I want repeated?',
    answer:
      'You can schedule a recurring request! We give you the option to schedule these recurring requests from your Dashboard. Choose the frequency at which the request should be repeated and you\'re all set.',
  },
  {
    question: 'Do you offer dedicated assistants?',
    answer:
      'Yes! We offer dedicated assistants for clients who need more personalized, consistent support. Contact us at contact@fancyhands.com about your needs and we\'ll get back to you as quickly as we can.',
  },
];

export const FaqPage = () => {
  return (
    <Box>
      <HeroSection
        title="Frequently Asked Questions"
        subtitle="Everything you need to know about Fancy Hands"
        variant="gradient"
      />
      <Container maxWidth="md" sx={{ py: { xs: 4, md: 8 } }}>
        <FaqAccordion items={faqItems} />
        <Box sx={{ mt: 6, textAlign: 'center' }}>
          <Typography variant="body1" color="text.secondary">
            Still have questions?{' '}
            <Typography
              component="a"
              href="mailto:contact@fancyhands.com"
              sx={{ color: 'primary.main', textDecoration: 'none' }}
            >
              Contact us
            </Typography>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};
